'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _Icon = require('./Icon');
var _Icon2 = _interopRequireDefault(_Icon);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
exports.default = _Icon2.default; /**
                                   * @name react-eva-icons
                                   * @author Dimitris Raptis
                                   * @copyright Dimitris Raptis 2018
                                   * @license MIT
                                   */